export default __webpack_public_path__ + "static/media/update-arrows.11d83344.svg";